export const medicamentos = {
    id: 'root',
    name: 'Medicamentos',
    children: [
        {
            id: '100',
            name: 'IECA',
            children: [
                { id: '101', name: 'Maleato de Enalapril 10mg' },
                { id: '102', name: 'Vasopril 10mg' },
                { id: '103', name: 'Vasopril Plus 20/12,5mg' },
                { id: '104', name: 'Captopril 25mg' },
                { id: '105', name: 'Ramipril 5mg' },
                { id: '106', name: 'Naprix 5mg' },
                { id: '107', name: 'Naprix D 5/12,5mg' },
                { id: '108', name: 'Naprix D 5/25mg' },
                { id: '109', name: 'Naprix A 2,5/5mg' },
                { id: '110', name: 'Naprix A 5/5mg' },
            ],
        },
        {
            id: '200',
            name: 'BRA',
            children: [
                { id: '201', name: 'Losartana 50mg' },
                { id: '202', name: 'Aradois 50mg' },
                { id: '203', name: 'Aradois H 50/12,5mg' },
                { id: '204', name: 'Torlós 50mg' },
                { id: '205', name: 'Torlós H 50/12,5mg' },
                { id: '206', name: 'Valsartana 80mg' },
                { id: '207', name: 'Diovan 80mg' },
                { id: '208', name: 'Diovan HCT 80/12,5mg' },
                { id: '209', name: 'Diovan HCT 160/25mg' },
                { id: '210', name: 'Diovan Amlo FIX 160/5mg' },
                { id: '211', name: 'Diovan Amlo FIX 320/5mg' },
                { id: '212', name: 'Olmesartana 20mg' },
                { id: '213', name: 'Benicar 20mg' },
                { id: '214', name: 'Benicar HCT 20/12,5mg' },
                { id: '215', name: 'Benicar Anlo 20/5mg' },
                { id: '216', name: 'Olmy Anlo 20/5mg' },
                { id: '217', name: 'Olmetec Anlo 20/5mg' },
                { id: '218', name: 'Telmisartana 40mg' },
                { id: '219', name: 'Bramicar 40mg' },
                { id: '220', name: 'Micardis 40mg' },
            ],
        },
        {
            id: '300',
            name: 'ENTRESTO',
            children: [
                { id: '301', name: 'Sacubitril/Valsartana 50mg' },
                { id: '302', name: 'Entresto 50mg' },
            ],
        },
        {
            id: '400',
            name: 'DIURÉTICOS',
            children: [
                { id: '401', name: 'Hidroclorotiazida 25mg' },
                { id: '402', name: 'Lasix 40mg' },
                { id: '403', name: 'Furosemida 40mg' },
                { id: '404', name: 'Indapen SR 1,5mg' },
                { id: '405', name: 'Natrilix 1,5mg' },
                { id: '406', name: 'Moduretic 50/5mg' },
                { id: '407', name: 'Moduretic 25/2,5mg' },
                { id: '408', name: 'Diupress 25/5mg' },
                { id: '409', name: 'Aldactone 25mg' },
                { id: '410', name: 'Espironolactona 25mg' },
                { id: '411', name: 'Clortalidona 25mg' },
                { id: '412', name: 'Aldazida 25mg' },
                { id: '413', name: 'Amilorida/Hidroclorotiazida 5/50mg' },
                { id: '414', name: 'Hidrion 40/100mg' },
            ],
        },
        {
            id: '500',
            name: 'BETABLOQUEADORES',
            children: [
                { id: '501', name: 'Propranolol 40mg' },
                { id: '502', name: 'Atenolol 50mg' },
                { id: '504', name: 'Ablok 50mg' },
                { id: '505', name: 'Ablok Plus 50/12,5mg' },
                { id: '506', name: 'Carvedilol 3,125mg' },
                { id: '507', name: 'Carvedilol 6,25mg' },
                { id: '508', name: 'Bisoprolol 5mg' },
                { id: '509', name: 'Concor 5mg' },
                { id: '510', name: 'Metoprolol 50mg' },
                { id: '511', name: 'Selozok 50mg' },
                { id: '512', name: 'Nebivolol 5mg' },
            ],
        },
        {
            id: '600',
            name: 'BLOQUEADORES CALCIO',
            children: [
                { id: '601', name: 'Anlodipina 5mg' },
                { id: '602', name: 'Roxflan 5mg' },
                { id: '603', name: 'Pressat 5mg' },
                { id: '604', name: 'Novanlo 5mg' },
                { id: '605', name: 'Adalat Oros 20mg' },
                { id: '606', name: 'Adalat Oros 30mg' },
                { id: '607', name: 'Adalat R 20mg' },
                { id: '608', name: 'Zanidip 20mg' },
            ],
        },
        {
            id: '700',
            name: 'ANTIAGREGANTES E ANTICOAGULANTES',
            children: [
                { id: '701', name: 'AAS 100mg' },
                { id: '702', name: 'Aspirina Prevent 100mg' },
                { id: '703', name: 'Somalgim Cardio 100mg' },
                { id: '704', name: 'Clopidogrel 75mg' },
                { id: '705', name: 'Plagrel 75mg' },
                { id: '706', name: 'Ticagrelor 90mg' },
                { id: '707', name: 'Brilinta 90mg' },
                { id: '708', name: 'Marevan 5mg' },
                { id: '709', name: 'Coumadin 5mg' },
                { id: '710', name: 'Pradaxa 110mg' },
                { id: '711', name: 'Pradaxa 150mg' },
                { id: '712', name: 'Xarelto 15mg' },
                { id: '713', name: 'Xarelto 20mg' },
                { id: '714', name: 'Rivaroxabana 20mg' },
                { id: '715', name: 'Apixabana 5mg' },
                { id: '716', name: 'Eliquis 5mg' },
                { id: '717', name: 'Embo 5mg' },
                { id: '718', name: 'Lixiana 60mg' },
            ],
        },
        {
            id: '800',
            name: 'DIGITÁLICO',
            children: [{ id: '801', name: 'Digoxina 0,25mg' }],
        },
        {
            id: '900',
            name: 'ANTIARRITMICOS',
            children: [
                { id: '9001', name: 'Ancoron 200mg' },
                { id: '9002', name: 'Amiodarona 200mg' },
                { id: '9003', name: 'Ritmonorm 300mg' },
                { id: '9004', name: 'Vatis 150mg' },
            ],
        },
        {
            id: '1000',
            name: 'DIABETES',
            children: [
                { id: '1001', name: 'Metformina 500mg' },
                { id: '1002', name: 'Metformina 850mg' },
                { id: '1003', name: 'Glifage XR 500mg' },
                { id: '1004', name: 'Glifage XR 750mg' },
                { id: '1005', name: 'Glibenclamida 5mg' },
                { id: '1006', name: 'Galvus 50mg' },
                { id: '1007', name: 'Galvus MET 50/500mg' },
                { id: '1008', name: 'Galvus MET 50/850mg' },
                { id: '1009', name: 'Glimepirida 4mg' },
                { id: '1010', name: 'Jardiance 25mg' },
                { id: '1011', name: 'Janumet 50/850mg' },
                { id: '1012', name: 'Dapagliflozina 10mg' },
                { id: '1013', name: 'Forxiga 10mg' },
                { id: '1014', name: 'Diamicron MR 60mg' },
                { id: '1015', name: 'Glyxambi 25/5mg' },
            ],
        },

        {
            id: '1100',
            name: 'TIREÓIDE',
            children: [
                { id: '1101', name: 'Puran T4 50mcg' },
                { id: '1102', name: 'Euthyrox 50mcg' },
                { id: '1103', name: 'Levotiroxina 50mcg' },
                { id: '1104', name: 'Synthroid 50mcg' },
            ],
        },
        {
            id: '1200',
            name: 'DISLIPIDEMIA',
            children: [
                { id: '1201', name: 'Sinvastatina 20mg' },
                { id: '1202', name: 'Clinfar 20mg' },
                { id: '1203', name: 'Sinvastacor 20mg' },
                { id: '1204', name: 'Atorvastatina 20mg' },
                { id: '1205', name: 'Lipitor 20mg' },
                { id: '1206', name: 'Citalor 20mg' },
                { id: '1207', name: 'Rosuvastatina 20mg' },
                { id: '1208', name: 'Crestor 20mg' },
                { id: '1209', name: 'Rosucor 20mg' },
                { id: '1210', name: 'Ciprofibrato 100mg' },
                { id: '1211', name: 'Lipless 100mg' },
                { id: '1212', name: 'Lipanon 250mg' },
                { id: '1213', name: 'Lopid 600mg' },
                { id: '1214', name: 'Trezor 20mg' },
                { id: '1215', name: 'Pivast 2mg' },
                { id: '1216', name: 'Zetsim 10/40mg' },
                { id: '1217', name: 'Ezetimiba 10mg' },
                { id: '1218', name: 'Trezete 20/10mg' },
                { id: '1219', name: 'Zinpass Eze 20/10mg' },
                {
                    id: '1220',
                    name: `USO EXTERNO\n
1.	Sybrava 1,5 ml\n
Aplicar 1 seringa SC , repetir dose após 3 meses, e após
Aplicar 1 seringa SC 6/6 meses\n
2.	Repatha 140 mg/ml
Aplicar  1seringa SC  a cada 15 dias`,
                },
                { id: '1221', name: 'Sybrava 1,5 ml' },
                { id: '1222', name: 'Repatha 140 mg/ml' },
            ],
        },
        {
            id: '1300',
            name: 'ANSIOLÍTICOS',
            children: [
                { id: '1301', name: 'Bromazepan 3mg' },
                { id: '1302', name: 'Lexotan 3mg' },
                { id: '1303', name: 'Alprazolan 2mg' },
                { id: '1304', name: 'Rivotril 0,5mg' },
            ],
        },
        {
            id: '1400',
            name: 'ANTIDEPRESSIVOS',
            children: [
                { id: '1401', name: 'Fluoxetina 20mg' },
                { id: '1402', name: 'Citalopran 20mg' },
                { id: '1403', name: 'Citta 20mg' },
                { id: '1404', name: 'Procimax 20mg' },
                { id: '1405', name: 'Escitalopran 10mg' },
                { id: '1406', name: 'Lexapro 10mg' },
                { id: '1407', name: 'Sertralina 50mg' },
            ],
        },
        {
            id: '1500',
            name: 'DIVERSOS',
            children: [
                { id: '1501', name: 'Zyloric 100' },
                { id: '1502', name: 'Zyloric 300mg' },
                { id: '1503', name: 'Omeprazol 40mg' },
                { id: '1504', name: 'Pantoprazol 40mg' },
                { id: '1505', name: 'Benzetacil 1.200.000UI' },
            ],
        },
        {
            id: '1600',
            name: 'Obesidade',
            children: [
                { id: '1601', name: 'Ozempic 1,5 ml (doses 0,25/0,5 mg)' },
                { id: '1602', name: 'Ozempic 3 ml ( dose 1 mg)' },
                { id: '1603', name: 'Saxenda' },
                {
                    id: '1604',
                    name: `Wegovy

Usar subcutâneo e manter em geladeira

1 - Wegovy 2,4mg
Aplicar 8 cliques por via SC (no abdome, coxa ou parte superior do braço) 1x/semana POR 4 semanas

2 - Wegovy 2,4mg
Aplicar 15 cliques por via SC (no abdome, coxa ou parte superior do braço) 1x/semana por 4 semanas - APÓS O TÉRMINO DO ITEM 1

3 - Wegovy 2,4mg
Aplicar 30 cliques por via SC (no abdome, coxa ou parte superior do braço) 1x/semana por 4 semanas - APÓS O TÉRMINO DO ITEM 2

4 - Wegovy 2,4mg
Aplicar 50 cliques por via SC (no abdome, coxa ou parte superior do braço) 1x/semana por 4 semanas - APÓS O TÉRMINO DO ITEM 3

5 - Wegovy 2,4mg
Aplicar 1 dose por via SC (no abdome, coxa ou parte superior do braço) 1x/semana POR USO CONTÍNUO - APÓS O TÉRMINO DO ITEM 4
`,
                },
                {
                    id: '1605',
                    name: `Mounjaro

Usar subcutâneo e manter em geladeira

1 - Mounjaro 2,5 mg/0,5 mL
Aplicar 1 ampola SC (no abdome, coxa ou parte superior do braço) 1x/semana POR 4 semanas

2 - Mounjaro 5 mg/0,5 mL
Aplicar 1 ampola SC (no abdome, coxa ou parte superior do braço) 1x/semana POR 4 semanas - APÓS O TÉRMINO DO ITEM 1

3 - Mounjaro 7,5 mg/0,5 mL
Aplicar 1 ampola SC (no abdome, coxa ou parte superior do braço) 1x/semana POR 4 semanas - APÓS O TÉRMINO DO ITEM 2

4 - Mounjaro 10 mg/0,5 mL
Aplicar 1 ampola SC (no abdome, coxa ou parte superior do braço) 1x/semana POR 4 semanas - APÓS O TÉRMINO DO ITEM 3

5 - Mounjaro 12,5 mg/0,5 mL
Aplicar 1 ampola SC (no abdome, coxa ou parte superior do braço) 1x/semana POR 4 semanas - APÓS O TÉRMINO DO ITEM 4

6 - Mounjaro 15 mg/0,5 mL
Aplicar 1 dose por via SC (no abdome, coxa ou parte superior do braço) 1x/semana POR USO CONTÍNUO - APÓS O TÉRMINO DO ITEM 5
`,
                },
            ],
        },
    ],
};

export const getPrescricao = (medicamento, counter) => {
  let prescricao = '';
  if (
    medicamento === 'Maleato de Enalapril 10mg' ||
    medicamento === 'Vasopril 10mg' ||
    medicamento === 'Carvedilol 3,125mg' ||
    medicamento === 'Carvedilol 6,25mg' ||
    medicamento === 'Ticagrelor 90mg' ||
    medicamento === 'Brilinta 90mg' ||
    medicamento === 'Ritmonorm 300mg' ||
    medicamento === 'Galvus MET 50/500mg' ||
    medicamento === 'Galvus MET 50/850mg' ||
    medicamento === 'Sacubitril/Valsartana 50mg' ||
    medicamento === 'Entresto 50mg' ||
    medicamento === 'Adalat R 20mg' ||
    medicamento === 'Apixabana 5mg' ||
    medicamento === 'Eliquis 5mg' ||
    medicamento === 'Embo 5mg' ||
    medicamento === 'Vatis 150mg'
  ) {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Tomar 1cp VO cedo e 1cp à noite.\n';
    return prescricao;
  }
  if (medicamento === 'Pradaxa 110mg' || medicamento === 'Pradaxa 150mg') {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Tomar 1cp VO cedo e à noite (12/12 horas).\n';
    return prescricao;
  }
  if (medicamento === 'Captopril 25mg' || medicamento === 'Propranolol 40mg') {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Tomar 1cp VO cedo, tarde e à noite.\n';
    return prescricao;
  }
  if (
    medicamento === 'AAS 100mg' ||
    medicamento === 'Aspirina Prevent 100mg' ||
    medicamento === 'Somalgim Cardio 100mg' ||
    medicamento === 'Clopidogrel 75mg' ||
    medicamento === 'Plagrel 75mg' ||
    medicamento === 'Lipanon 250mg' ||
    medicamento === 'Xarelto 15mg' ||
    medicamento === 'Xarelto 20mg' ||
    medicamento === 'Rivaroxabana 20mg'
  ) {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Tomar 1cp VO após o almoço.\n';
    return prescricao;
  }
  if (medicamento === 'Marevan 5mg' || medicamento === 'Coumadin 5mg') {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Tomar 1cp VO à tarde.\n';
    return prescricao;
  }
  if (
    medicamento === 'Metformina 500mg' ||
    medicamento === 'Metformina 850mg' ||
    medicamento === 'Glifage XR 500mg' ||
    medicamento === 'Glifage XR 750mg'
  ) {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Tomar 1cp VO após o almoço e 1cp após o jantar.\n';
    return prescricao;
  }
  if (
    medicamento === 'Puran T4 50mcg' ||
    medicamento === 'Euthyrox 50mcg' ||
    medicamento === 'Synthroid 50mcg' ||
    medicamento === 'Levotiroxina 50mcg'
  ) {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao +=
      '      Tomar 1cp VO cedo (30 minutos antes do café da manhã).\n';
    return prescricao;
  }
  if (
    medicamento === 'Sinvastatina 20mg' ||
    medicamento === 'Clinfar 20mg' ||
    medicamento === 'Sinvastacor 20mg' ||
    medicamento === 'Trezor 20mg' ||
    medicamento === 'Ciprofibrato 100mg' ||
    medicamento === 'Lipless 100mg' ||
    medicamento === 'Lopid 600mg' ||
    medicamento === 'Bromazepan 3mg' ||
    medicamento === 'Lexotan 3mg' ||
    medicamento === 'Alprazolan 2mg' ||
    medicamento === 'Rivotril 0,5mg' ||
    medicamento === 'Pivast 2mg' ||
    medicamento === 'Zetsim 10/40mg' ||
    medicamento === 'Ezetimiba 10mg'
  ) {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Tomar 1cp VO à noite.\n';
    return prescricao;
  }
  if (
    medicamento === 'Atorvastatina 20mg' ||
    medicamento === 'Lipitor 20mg' ||
    medicamento === 'Citalor 20mg' ||
    medicamento === 'Rosuvastatina 20mg' ||
    medicamento === 'Crestor 20mg' ||
    medicamento === 'Rosucor 20mg' ||
    medicamento === 'Trezor 20mg' ||
    medicamento === 'Trezete 20/10mg' ||
    medicamento === 'Zinpass Eze 20/10mg' ||
    medicamento === 'Zinpass Eze 40/10mg'
  ) {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Tomar 1cp VO ao dia.\n';
    return prescricao;
  }
  if (medicamento === 'Omeprazol 40mg' || medicamento === 'Pantoprazol 40mg') {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Tomar 1cp VO cedo em jejum.\n';
    return prescricao;
  }
  if (medicamento === 'Janumet 50/850mg') {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao +=
      '      Tomar 1cp VO após café da manhã e 1cp após o jantar.\n';
    return prescricao;
  }
  if (medicamento === 'Benzetacil 1.200.000UI') {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao += '      Aplicar IM em musculatura profunda de 21/21 dias.\n';
    return prescricao;
  }
  if (medicamento === 'Ozempic 1,5 ml (doses 0,25/0,5 mg)') {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao +=
      '      Aplicar SC 1x/semana (sempre no mesmo horário)\n      Manter em geladeira\n            - 0,25 mg SC 1x/semana por 4 semanas, após\n            - 0,5 mg SC 1x/semana por pelo menos 4 semanas.\n';
    return prescricao;
  }
  if (medicamento === 'Ozempic 3 ml ( dose 1 mg)') {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao +=
      '      Aplicar SC 1x/semana (sempre no mesmo horário)\n      Manter em geladeira\n            - 17 cliques SC 1x/semana por 4 semanas, após\n            - 34 cliques SC 1x/semana por 4 semanas, após\n            - 1 mg SC 1x/semana por 4 semanas pelo menos (dose máxima)\n';
    return prescricao;
  }
  if (medicamento === 'Saxenda') {
    prescricao += `${counter} - ${medicamento}\n`;
    prescricao +=
      '      Agulha Novofine 4 mm\n      Manter em geladeira\n      Aplicar SC 1x/dia (sempre no mesmo horário)\n            - 0,6 mg SC 1x/dia por 1 semana, após aumentar +2 cliques a cada 2 dias\n            - 1,2 mg SC 1x/dia por 1 semana\n            - 1,8 mg SC 1x/dia por 1 semana\n            - 2,4 mg SC 1x/dia por 1 semana\n            - 3 mg SC 1x/dia (dose máxima)\n';
    return prescricao;
  }
  prescricao += `${counter} - ${medicamento}\n`;
  prescricao += '      Tomar 1cp VO cedo.\n';
  return prescricao;
};